// tslint:disable:max-line-length

import React from 'react';

export const DatatypeCurrency = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.31,14.06a5,5,0,0,1-4-2.54L5,10.4a3.87,3.87,0,0,0,2.35,1.86V8.86C5.45,8.38,3.61,7.68,3.61,5.4c0-2,1.44-3.31,3.7-3.48V.81H8.85V2a4.67,4.67,0,0,1,3.44,2.12L10.56,5.32A3.12,3.12,0,0,0,8.8,3.87V7c2.23.53,3.91,1.3,3.91,3.55,0,1.76-1.14,3.28-3.86,3.52v1.35H7.31ZM7.39,3.77C6.43,3.9,6,4.46,6,5.18s.48,1.15,1.41,1.44Zm1.41,8.5c1-.14,1.54-.61,1.54-1.49S9.84,9.55,8.8,9.23Z" />
    </svg>
  );
};
